import { createFileRoute } from '@tanstack/react-router'
import { CalendarPage } from '@/features/scheduler'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/'
)({
  component: CalendarPage,
})
